<template>
  <v-card class="mb-3">
    <v-list-item>
      <v-list-item-content>
        {{$t('productInfo_title1')}}
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <div class="d-flex flex-no-wrap justify-space-between">
      <v-avatar
        class="my-3 ml-3 mr-0"
        size="100"
        tile
      >
        <v-img :src="shop_info.product_img"></v-img>
      </v-avatar>
      <v-card-text>
        <p class="title mb-0">
          {{ shop_info.product_name }}
        </p>
        <p class="subtitle-2 font-weight-light">
          {{ shop_info.product_spec }}
        </p>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'priceInfo',

  data: () => ({
    access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
    user_uuid: '',
    group_uuid: '',
    shop_info: [],
  }),
  methods: {
    getShopInfo() {
      if (this.$store.state.productinfo.productinfoData !== undefined &&
        this.$store.state.productinfo.productinfoData.length > 0) {
        this.shop_info = this.$store.state.productinfo.productinfoData[0];
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getShopInfo();
  },
  watch: {
  },
};
</script>
